import React, { FunctionComponent } from "react";

import styles from "./MenuList.module.scss";

export const MenuListItem: FunctionComponent = ({ children }) => <li className={styles.menuListItem}>{children}</li>;
